import { type PlanBase } from '@/api/initial-state';

type FindRule = (plan: PlanBase, idx: number) => boolean;

export default function planQueryBuilder() {
  const urlHasPlanAlias: FindRule = (plan: PlanBase) => {
    const urlParams = new URLSearchParams(window.location.search);
    const urlPackage = urlParams.get('package') as string;

    return plan['item-package'] === urlPackage;
  };

  const hasBestPrice: FindRule = (plan: PlanBase) => {
    return plan['item-best-value-price'];
  };

  const matchItemByProp: <T extends keyof PlanBase>(
    prop: T,
    value: PlanBase[T],
  ) => FindRule = (prop, value) => {
    return (plan: PlanBase) => {
      return plan[prop] === value;
    };
  };

  const getFrom = (plans: PlanBase[]) => {
    const conditions: (FindRule | FindRule[])[] = [];

    return {
      default() {
        return plans[0] as PlanBase;
      },
      or(rules: FindRule | FindRule[]) {
        conditions.push(rules);

        return this;
      },
      get() {
        let selectedPlan: PlanBase | undefined;

        for (const rules of conditions) {
          if (Array.isArray(rules)) {
            selectedPlan = plans.find((plan, idx) => {
              return rules.every((rule) => rule(plan, idx));
            });
          } else {
            selectedPlan = plans.find(rules);
          }

          if (selectedPlan) {
            break;
          }
        }

        return selectedPlan ?? this.default();
      },
    };
  };

  return {
    urlHasPlanAlias,
    hasBestPrice,
    matchItemByProp,
    getFrom,
  };
}
